import React from 'react';

import { sendRequest } from '../global';

export default class CourierRewardsInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mailingStates: [],
    };
  }

  componentDidMount = () => {
    sendRequest({
      method: 'mailing_states/all',
      type: 'GET',
      success: (data) => {
        this.setState({mailingStates: data});
      },
      error: (xhr, status, err) => {
      }
    });
  }

  handleChange = (value) => {
    this.props.onChange(this.props.objectKey, value);
  }

  componentWillReceiveProps = (props) => {
  }

  renderStateRow = (stateItem) => {
    const rewardItem = (this.props.object || []).find(i => i.id === stateItem.id);
    return (
      <tr key={stateItem.id}>
        <td className='stateName'>{stateItem.name}</td>
        <td className='stateReward'>
          <input
            type='number'
            value={rewardItem ? rewardItem.reward || '' : ''}
            readOnly={this.props.disabled}
            onChange={e => {
              this.handleChange(rewardItem
                ? this.props.object.map(i => i.id === rewardItem.id ? {
                  ...rewardItem,
                  reward: e.target.value
                } : i)
                : [...this.props.object, {
                  id: stateItem.id,
                  reward: e.target.value,
                }]
              )
            }}
          />
        </td>
      </tr>
    )
  }

  render = () => {
    return (
      <table className='courierRewards'>
        <thead>
          <tr>
            <th>Статус</th>
            <th>руб.</th>
          </tr>
        </thead>
        <tbody>
          {this.state.mailingStates.map(this.renderStateRow)}
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/CourierRewardsInput.js